import styled, { css } from 'styled-components';
import { FONTS, COLORS, SIZE } from '@app/src/ui';
import { HeaderFeature } from '@app/src/common/header';

interface Props {
  color?: string;
  isChangeOrientation?: boolean;
}

export const Information = styled.h1`
  font-family: ${FONTS.MONTSERRAT_BOLD};
  font-size: 24px;
  font-weight: 400;
  margin: 0 auto;
  text-align: center;
  color: ${COLORS.BLACK};

  @media (min-width: ${SIZE.TABLET_LANDSCAPE}) {
    font-family: ${FONTS.MONTSERRAT_BOLD};
    font-size: 40px;
    text-align: center;
  }
`;

export const WrapperIcons = styled.a`
  width: 60px;
  height: 60px;
  margin-bottom: 16px;
  display: inline-flex;
  cursor: pointer;
  border-radius: 10px;
  align-items: center;
  justify-content: center;
  box-shadow: 0px 4px 8px #00000029;

  ${(props: Props) => props.color && css`
    background-color: ${props.color};
  `}

  a {
    color: ${COLORS.BLACK};
    display: inline-block;
    text-align: center;
    cursor: pointer;
  }

  span {
    display: block;
  }

  @media (min-width: ${SIZE.TABLET_LANDSCAPE}) {
    width: 96px;
    height: 96px;
  }
`;

export const Sections = styled.div`
  display: flex;
  flex-wrap: wrap;
  justify-content: center;
  font-size: 13px;
  box-sizing: border-box;
  position: relative;
  margin: 24px auto 48px;

  @media (min-width: ${SIZE.TABLET_LANDSCAPE}) {
    min-height: auto;
  }
`;

export const Title = styled.span`
  font-family: ${FONTS.ROBOTO_BOLD};
  font-size: 11px;
  color: ${COLORS.BLACK};
  text-transform: uppercase;
  display: block;

  @media (min-width: ${SIZE.TABLET_LANDSCAPE}) {
    font-size: 14px;
  }
`;

export const TopSection = styled.div`
  padding: 50px 15px;
  display: flex;
  flex-direction: column;
  align-items: center;
  text-align: center;

  @media (min-width: ${SIZE.TABLET_LANDSCAPE}) {
    padding: 85px 0 89px;
  }
`;

export const HeaderFeatureWrapper = styled(HeaderFeature)`
  background: transparent;
  @media(min-width: ${SIZE.TABLET_LANDSCAPE}) {
    background-color: #fafafa;
  }
`;

export const CategoryWrapper = styled.div`
  text-align: center;
  margin-bottom: 12px;
  width: 120px;

  @media (min-width: ${SIZE.TABLET_LANDSCAPE}) {
    margin-left: 0;
    width: auto;

    &:not(:first-child) {
      margin-left: 45px;
    }
  }
`;

export const Publish = styled.p`
  color: #8971DE;
  font-size: 20px;
  font-family: ${FONTS.MONTSERRAT};
  width: 228px;

  @media (min-width: ${SIZE.TABLET_LANDSCAPE}) {
    font-size: 24px;
    width: auto;
  }
`;
